export default __webpack_public_path__ + "static/media/emailIcon.964bc833.svg";